import Phaser, {
    Display
} from 'phaser'

let _this;
let sounds;
let utils;
let toolTips;
let hand;
let handAdjust;
let gameScale;
//let clickX;
let guide;
//Add default for testing
let currentLocation = '';
let currentPanel = '';

export default class Navigate extends Phaser.Scene {
    constructor() {
        super('navigate')
    }
    init() {
        gameScale = this.registry.get('scaleIt');
        _this = this;
        sounds = this.scene.get('sounds');
        utils = this.scene.get('utils');
    }

    create() {
        //Add the hand for an over graphic
        hand = utils.addImage(this, {
            id: 'hand'
        })

        hand.visible = false;
        handAdjust = 17 * gameScale;
        if (this.registry.values.isMobile) handAdjust = -1 * (handAdjust + 5 * gameScale);

        //move the hand based on pointer
        this.input.on('pointermove', this.updateHand);

        //Record the startx of the click
        /*this.input.on('pointerdown', () => {
            clickX = Math.ceil(this.input.activePointer.x);
        });
*/
        //refer often to the guide scene
        guide = this.scene.get('guide');
        //guide.events.on('ready', this.guideReady, this);
        guide.events.on('create', this.guideReady, this);
        toolTips = _this.scene.get('toolTips');
    }

    //Called from the guide scene when the bubble is ready
    guideReady() {
        //Hide the over hand graphic when user rolls over the speech bubble
        guide.getBubble().on('pointerover', this.hideHand);
    }

    //A location has been clicked
    clickLocation() {
        //to avoid accidental clicks while dragging around the world compare the down x to the up x 
        //Leave wiggle room for fingers

        let downX = _this.input.activePointer.downX;
        let pointX = Math.ceil(_this.input.activePointer.x);

        let diff = Math.abs(pointX - downX);
        if (diff > 4) return;
        //the start down and end up positions matched, so off we go!
        //Roll off the location
        _this.outLocation(this);
        //Play sound feedback
        //sounds.playClick();
        _this.handleLocation({
            location: this.getData('location'),
            img: this
        })

        sounds.playClick();
    }

    handleLocation(data) {
        toolTips.outTool();

        let thisOverlay = 'overlay';
        //Are we coming from the world scene or already from within a scene?
        let isLocation = false;
        if (_this.scene.isActive('world')) {
            isLocation = true;
        }

        //this is the object that was clicked. It holds info
        let location = data.location; //this.getData('location');
        //Pause guide in order to help reset it and guide animate and let the location reactivate it


        //Let's see what has been clicked
        switch (location) {
            //One of the major locations that uses location.js as it's base
            case 'auntyKewa':
            case 'wharenui':
            case 'kaumatuaPorch':
            case 'kaumatua':
                currentLocation = location;
                _this.scene.run(location, {
                    location: location
                });
                _this.scene.bringToTop(location);

                break;

                //An overlay has been clicked   
            case 'matching':
            case 'dictionary':
                _this.scene.bringToTop('overlay');
                thisOverlay = location;

            default:
                currentPanel = location;
                _this.scene.pause(currentLocation);
                _this.scene.pause('guide');

                _this.scene.run(thisOverlay, {
                    location: location,
                    img: data.img,
                    isLocation: isLocation
                });

                _this.scene.bringToTop(thisOverlay);

                break;

        }
        //These are always on the top
        _this.scene.bringToTop('navigate');
        _this.scene.bringToTop('toolTips');

        _this.scene.bringToTop('menu');
        _this.scene.pause('world');

        _this.scene.get('menu').showHideMatch(false);
    }

    //Event Handler for home button
    goHome() {
        _this.scene.pause('guide');

        let navigate = this.scene.get('navigate');
        let world = this.scene.get('world');

        sounds.playClick();
        //set guide to default settings
        guide.removeBubble();

        let guideImg = guide.getGuide();
        guideImg.on('pointerover', navigate.hideHand);
        guideImg.on('pointerup', world.stopFollow);

        //check if world scene is active
        if (this.scene.isActive('world')) {
            this.scene.get('world').resetWorldScroll();
            return;
        }
        sounds.setBackgroundSound('birdsong', 0.05);
        //We are in a location so lets leave to go home
        //Gather a list of all the scenes
        let sceneList = this.scene.manager.getScenes(false, false);

        let thisKey;
        //Go through the various scene keys
        for (let index = 0; index < sceneList.length; index++) {
            thisKey = sceneList[index].scene.key;

            switch (thisKey) {

                case 'auntyKewa':
                case 'wharenui':
                case 'overlay':
                case 'kaumatuaPorch':
                case 'kaumatua':
                case 'dictionary':
                case 'matching':

                    this.scene.stop(thisKey);

                    break;
                default:
                    break;
            }



        }
        //Finally no matter what the scene is we have to start up the world scene again
        this.scene.resume('world');
        world.stopFollow();
        currentPanel = '';
        currentLocation = '';
        _this.scene.get('menu').showHideMatch(true);

        guide.setupGuide({});
    }

    //Called to close the overlays but remain in the orignating scene
    //Now also called when overlay is called from home
    closeIt() {
        //Was the close button clicked in one of the overlays that is it's own location?
        if (!currentLocation) {
            _this.goHome();
            return;
        }

        //Close the overlay and resume the location we are in
        _this.scene.stop(this);
        //resume the current Scene
        _this.scene.run(currentLocation);
        //resume the guide
        _this.scene.resume(guide);

        sounds.playBackgroundSound();
    }


    //Add the listeners for a location object
    setupLocation() {
        let obj = arguments[0].obj;
        let f = arguments[0].callback || this.clickLocation;
        //The object might be a container
        try {
            obj.setOrigin(0.5, 0.5);
            obj.x += obj.displayWidth / 2;
            obj.y += obj.displayHeight / 2;
        } catch {}

        //use setData as it works with both images and containers
        obj.setData('scale', obj.scale);
        //obj.setDataEnabled();
        //obj.data.set('scale', obj.scale);


        //  this.input.enableDebug(obj, 0xffcc00);
        //In case an object is sent here more than once (ie, guide)
        obj.off('pointerup');
        obj.off('pointerover');
        obj.off('pointerout');
        obj.on('pointerup', f);
        obj.on('pointerover', this.onLocation);
        obj.on('pointerout', this.outLocation.bind(obj, obj));
    }

    //Rollover state for the locations
    onLocation() {
        _this.scene.bringToTop('navigate');
        _this.updateHand();

        toolTips.outTool();
        toolTips.onTool(this);
        this.scale += this.data.get('scale') * 0.1 || 0.1;
        hand.visible = true;
        //  clickX = _this.input.activePointer.x;
    }
    outLocation(obj) {
        toolTips.outTool();
        obj.scale = obj.data.get('scale') || 1;
        _this.input.setDefaultCursor('default');
        hand.visible = false;
    }
    updateHand() {
        hand.x = _this.input.activePointer.x - handAdjust;
        hand.y = _this.input.activePointer.y - handAdjust;
    }

    //Sometimes we want to hide the hand, when over guide's speech bubble
    hideHand(val = false) {
        hand.visible = false;
        //  try {
        //there may or may not be an active tooltip, but hide it if it's there
        toolTips.outTool();
        //} catch {

        //}
    }

    getPanel() {
        return (currentPanel);
    }
    getLocation() {
        return (currentLocation);
    }

}